import FormGroup from "../components/FormGroup";
import React, {useRef, useState} from "react";
import {useParams} from "react-router-dom";
import {useFormik} from "formik";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {UsersService} from "../services/UsersService";
import {Toast} from "primereact/toast";
import Loader from "../components/Loader";

export default function UserEditPassword() {

    const props = useParams()
    const toast = useRef(null);
    const [sending, setSending] = useState(false)
    const userId = props.userId

    const formik = useFormik({
        initialValues: {
            password: '',
            password_repeat: ''
        },
        validate: (values, props) => {
            const errors = {};

            if (!values.password) {
                errors.password = 'Обязательное поле!';
            }

            if (!values.password_repeat) {
                errors.password_repeat = 'Обязательное поле!';
            }

            if (values.password !== values.password_repeat) {
                errors.password_repeat = 'Пароли не совпадают.';
            }


            return errors
        },
        onSubmit: (data) => {
            setSending(true)
            UsersService.ChangePassword(userId, data.password).then((response) => {
                if (response.id) {
                    toast.current.show({severity: 'success', summary: 'Пароль успешно изменен!'});
                } else {
                    toast.current.show({severity: 'error', summary: 'Ошибка!'});
                }
                setSending(false)
            })
            formik.resetForm()
        }
    })

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    return (
        <div className="card">

            <div className="card-body">
                <form className={'theme-form'} onSubmit={formik.handleSubmit}>
                    <Toast ref={toast}></Toast>

                    <h3 className={'m-b-30'}>Смена пароля</h3>

                    <div className="row m-b-30">
                        <div className="col">
                            <div className={'d-flex flex-column gap-2'}>
                                <label htmlFor="password">Новый пароль</label>
                                <InputText type={'password'} id={'password'} name={'password'}
                                           value={formik.values.password}
                                           onChange={(e) => formik.setFieldValue('password', e.target.value)}
                                           className={classNames({'p-invalid': isFormFieldInvalid('password')})}/>
                                {getFormErrorMessage('password')}
                            </div>
                        </div>
                        <div className="col">
                            <div className={'d-flex flex-column gap-2'}>
                                <label htmlFor="password_repeat">Повторите новый пароль</label>
                                <InputText type={'password'} id={'password_repeat'} name={'password_repeat'}
                                           value={formik.values.password_repeat}
                                           onChange={(e) => formik.setFieldValue('password_repeat', e.target.value)}
                                           className={classNames({'p-invalid': isFormFieldInvalid('password_repeat')})}/>
                                {getFormErrorMessage('password_repeat')}
                            </div>
                        </div>
                    </div>

                    <button type={'submit'} className={'btn btn-primary'}>Изменить пароль</button>

                    {sending && <Loader/>}
                </form>
            </div>
        </div>
    )

}